import React from "react";
import loadable from "@loadable/component";
// import RegistrationFormContentLoader from "../../components/Registration/widgets/RegistrationFormContentLoader";
import LoginFormContentLoader from "../Registration/widgets/LoginFormContentLoader";

const ContentLoaderFunction: React.FC = () => {
    return <LoginFormContentLoader />;
};
export default loadable(() => import(/* webpackChunkName: 'login' */ "../Login"), {
    fallback: <ContentLoaderFunction />,
});
